// The tenant this build is for (tenants/<id>.json, chosen by TENANT at build time). Every name,
// word and example the user sees comes from here, so a second tenant is a config file, not a fork.
import type { TenantConfig } from '../../tenants/load';

declare const __TENANT__: Omit<TenantConfig, 'tokens'>;

export const tenant = __TENANT__;
/** Capitalised words ("Workspace", "Lesson") and the lower-case forms for running text. */
export const T = tenant.terms;
export const t = Object.fromEntries(Object.entries(T).map(([k, v]) => [k, v.toLowerCase()])) as typeof T;
export const ex = tenant.examples;
